import Cookies from 'universal-cookie';

export function setCookie(name, value, options) {
  const cookies = new Cookies();

  options = options || {};
  options.path = '/';

  cookies.set(name, value, options);
  // TODO: domain, secure, httpOnly set edilecek
}

export function hasCookie(name) {
  const cookies = new Cookies();

  return cookies.get(name || 'X-AUTH-TOKEN') !== undefined;
}

export function removeCookie(name) {
  const cookies = new Cookies();

  cookies.remove((name || 'X-AUTH-TOKEN'), { path: '/' });
}

export function getCookie(name) {
  const cookies = new Cookies();

  return cookies.get(name);
}
